import * as React from 'react'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider/LocalizationProvider'
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { FormControl } from '@mui/material'

import moment from 'moment'
import 'moment/locale/pt-br'

moment.locale('pt-br')

export default function DateInput({
  label,
  value = null,
  onChange,
  className,
  minDate = moment().subtract(110, 'years'),
  maxDate = moment().subtract(10, 'years'),
  fullWidth = true,
}) {
  return (
    <FormControl fullWidth={fullWidth} variant='filled' className={className}>
      <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale={'pt-br'}>
        <DatePicker
          label={label}
          minDate={minDate}
          maxDate={maxDate}
          format='DD/MM/YYYY'
          value={value}
          onChange={onChange}
        />
      </LocalizationProvider>
      {/* <helperText>{helperText}</helperText> */}
    </FormControl>
  )
}
